var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightAlignmentButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.75 1.5C22.1642 1.5 22.5 1.83579 22.5 2.25V21.75C22.5 22.1642 22.1642 22.5 21.75 22.5C21.3358 22.5 21 22.1642 21 21.75V2.25C21 1.83579 21.3358 1.5 21.75 1.5Z",
    fill: "#585858"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 7.125C4.5 6.50368 5.05964 6 5.75 6H18.25C18.9404 6 19.5 6.50368 19.5 7.125V9.375C19.5 9.99632 18.9404 10.5 18.25 10.5H5.75C5.05964 10.5 4.5 9.99632 4.5 9.375V7.125Z",
    fill: "#585858"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 14.625C1.5 14.0037 2.17157 13.5 3 13.5H18C18.8284 13.5 19.5 14.0037 19.5 14.625V16.875C19.5 17.4963 18.8284 18 18 18H3C2.17157 18 1.5 17.4963 1.5 16.875V14.625Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightAlignmentButton);
export default __webpack_public_path__ + "static/media/rightAlignmentButton.0dab9340c8173d6a8f8161924f693429.svg";
export { ForwardRef as ReactComponent };